import * as Pet from 'src/replicant/pet';
import { MutableState } from 'src/replicant/State';
import * as Visit from 'src/replicant/visit';
import type { ScheduledActionAPI } from 'src/replicant/utils/types';
import { endVisitAction } from 'src/replicant/visit/visit.util';
import { updateRaceBotsOnGameEnd } from 'src/replicant/match2/races/races.bots';
import { updateWeeklyLeaderboardPlayerRank } from 'src/replicant/weeklyLeaderboard/weeklyLeaderboard.modifiers';

export const endSession = async (
  state: MutableState,
  api: ScheduledActionAPI,
) => {
  const now = api.date.now();

  // Update race bots logic
  updateRaceBotsOnGameEnd(state, now);

  // Auto spawn feature - check if there is a pet already
  const currentSpecies = Pet.getters.getEquippedPetSpecies(state);

  // if no pet, create first pet automatically
  if (!currentSpecies) {
    Pet.modifiers.createFirstPet(state, now, () => api.math.random());
  }

  const chatbot = require('../../chatbot').default;
  await chatbot.events.onGameEnd(state, null, api, true);

  if (Visit.getters.isVisiting(state)) {
    endVisitAction(() => undefined, state, api);

    delete state.visit.visitSession;
  }

  // Update weekly leaderboard user rank
  await updateWeeklyLeaderboardPlayerRank(state, api);
};
